import "./modell.scss";
import ButtonSolid, {
  ButtonSolidType,
} from "components/buttonSolid/buttonSolid";
import Slider, { sliderProps } from "components/slider/slider";

interface modellProps {
  header: {
    title: string;
    copy: string;
  };
  button: ButtonSolidType;
  slider: sliderProps;
}

const Modell: React.FC<modellProps> = (props) => {
  return (
    <div className="modell">
      <div className="modell__inner">
        <div className="wrapper--small">
          <h1>{props.header.title}</h1>
          <p>{props.header.copy}</p>
        </div>
        <Slider {...props.slider} />
        <ButtonSolid {...props.button} glow />
      </div>
    </div>
  );
};

export default Modell;
